import logo from "../images/logo.png";

function Footer() {
  return (
    <footer className="bg-[rgba(240,228,211,0.5)] border-t border-[rgba(217,162,153,0.2)] mt-20 py-12 text-center">
      <img
        src={logo}
        alt="Nymfodora Giannakidou"
        className="h-16 w-auto mx-auto mb-4"
      />

      <p className="font-lora font-semibold text-[#3a3a3a] text-sm mb-1">
        Nymfodora Giannakidou
      </p>
      <p className="text-[#9a9a9a] text-[0.7rem] tracking-[0.12em] uppercase mb-6">
        MBACP Registered Counsellor
      </p>

      <div className="flex justify-center gap-5 mb-8">
        <a
          href="https://www.instagram.com/nymfodora_counselling?igsh=MThuZzluOWp4NjRibQ=="
          className="text-[#9a9a9a] hover:text-[#b07068] transition-colors"
          aria-label="Instagram"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fa-brands fa-instagram fa-lg"></i>
        </a>
        <a
          href="https://www.facebook.com/share/1JNkH2RHfG/?mibextid=wwXIfr"
          className="text-[#9a9a9a] hover:text-[#b07068] transition-colors"
          aria-label="Facebook"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fa-brands fa-facebook fa-lg"></i>
        </a>
        <a
          href="https://wa.me/447826804677"
          className="text-[#9a9a9a] hover:text-[#b07068] transition-colors"
          aria-label="WhatsApp"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fa-brands fa-whatsapp fa-lg"></i>
        </a>
      </div>

      <p className="text-[#b0b0b0] text-xs">
        © 2026 Nymfodora Giannakidou. All Rights Reserved.
      </p>
      <p className="text-[#b0b0b0] text-xs mt-1">
        Designed by{" "}
        <a
          href="https://layernine.co.uk/"
          className="text-[#b0b0b0] hover:text-[#7a7a7a] transition-colors"
          target="_blank"
          rel="noopener noreferrer"
        >
          LayerNine
        </a>
      </p>
    </footer>
  );
}

export default Footer;
